import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import DatePicker from 'material-ui/DatePicker';
import RaisedButton from 'material-ui/RaisedButton';

import sortBy from 'lodash.sortby';

import { getOrdersByDateRange, formatNumber } from '../../utils/orderService';
import {
  Header,
} from '../Styles/index';
import OrdersTable from './OrderTable'; 
import LoadingState from '../Loading';
import { STATUSES } from './EditOrder';

const Container = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  padding: 32px 16px;
` 
const TableContainer = styled.div`

`


class OrdersByDate extends Component {

  state = {
    status: 'all',
    orders: [],
    total: 0,
    autoOk: true,
    orderBy: 'no',
    orderByItems: ['no', 'date', 'amount', 'client'],
    dateFrom: '',
    dateTo: new Date(),
    loading: false,
  }

  _orderBy(value){
    switch (value) {
      case 'date':
        return sortBy(this.state.orders, value =>  new Date(value.date));
      case 'amount': 
        return sortBy(this.state.orders, order => {
          let amount = 0;
          for (const key in order.products) {
            amount += order.products[key];
          } 
          return amount
        });
      case 'client':
        return sortBy(this.state.orders, order => order.client.name)
      default:
        return sortBy(this.state.orders, [value]);
    }
  }

  _handleChange = (event, index, value) => {
    const orders = this._orderBy(value);
    console.log(orders)
    this.setState({
      orderBy: value,
      orders
    });
  }

  _goToEditPage = (code) => {
    this.props.history.push(`/orders/edit?order=${code}`);
  }

  _refreshPage = () => {
   
  }

  _handleFromDate = (event, date) => {
    this.setState({
      dateFrom: date
    })
  }

  _handleToDate = (event, date) => {
    this.setState({
      dateTo: date
    })
  }

  _handleSelect = (event, index, value) => {
    this.setState({
      status: value
    });
  }

  _handleSearchOrders = async (event) => {
    try {
      event.preventDefault();
      this.setState({ loading: true })
      if (this.state.dateFrom === '') {}
      const dateFrom = this.state.dateFrom === '' ? 0 :  this.state.dateFrom.getTime();
      let orders = await getOrdersByDateRange(dateFrom, this.state.dateTo.getTime());

      if (this.state.status !== 'all' ) {
        orders = orders.filter(order => order.status === this.state.status)

      }

      const total = orders.reduce((sum, order) => sum + order.amount, 0)

      this.setState({
        orders,
        total,
        loading: false,
      })
    } catch(e) {
      this.setState({ orders: [], loading: false })
      console.log(e);
    }
    
  }



  async componentWillMount() {
    
  }

  render(){
    // const tableHeader = ['No', 'Date', 'Amount', 'Client', 'Status', 'Notes', ''];
    const tableHeader = ['No', 'Date', 'Amount', 'Client', 'Status', 'Active', 'Notes', ''];
    return(
      <Container>
        <Header>
          <div style={{flex: 1, height: '74px', paddingRight: '24px'}}>
            <SelectField
              floatingLabelText="Sort By"
              value={this.state.orderBy}
              onChange={this._handleChange}
            >
              {this.state.orderByItems.map((item, index) => <MenuItem key={index} value={item} primaryText={item}/>)}
            </SelectField>
          </div>
          <div>
            <form onSubmit={this._handleSearchOrders} >
              <div style={{ paddingRight: '12px', display: 'flex', alignItems: 'flex-end' }}>
                <div>
                  <label htmlFor="">Date from</label>
                  <DatePicker textFieldStyle={{ width: '96px' }} hintText="Date from " autoOk={this.state.autoOk} onChange={this._handleFromDate} />
                </div>
                <div style={{ paddingLeft: '12px'}}>
                  <label htmlFor="">Date to</label>
                  <DatePicker textFieldStyle={{ width: '96px' }} hintText="Date to" autoOk={this.state.autoOk} defaultDate={this.state.dateTo} onChange={this._handleToDate} />
                </div>
                <div style={{ paddingLeft: '12px'}}>
                  <SelectField
                    floatingLabelText="Order Status"
                    value={this.state.status}
                    style={{ width: '200px' }}
                    onChange={this._handleSelect}
                  >
                    <MenuItem key={'all'} value={'all'} primaryText="All" />
                    {STATUSES.map(s => s)}
                  </SelectField>
                </div>
                <div style={{ paddingLeft: '12px'}}>
                  <RaisedButton type='submit' label="Search" primary={true} />
                  <div style={{ height: '8px' }}></div>
                </div>
              </div>
            </form>
          </div>
          <div style={{ flex: 1 }}></div>
        </Header>
        <div style={{ height: '16px' }}></div>
        <div>
          <TableContainer>
            { !this.state.loading && this.state.orders.length !== 0 && <OrdersTable  
              refreshPage={this._refreshPage}  
              headers={tableHeader} 
              editHandler={this._goToEditPage} 
              tableData={this.state.orders} 
              height={this.state.orders.length*48}
            />}
          </TableContainer>
        </div>
        {(this.state.orders.length !== 0) && <div style={{ padding: '16px 8px' }}>
          <p style={{ fontSize: '18px'}}>Totali: <span style={{ fontWeight: '600' }}>{formatNumber(this.state.total)} L</span></p>
        </div>}
        {this.state.loading && <LoadingState />}
      </Container>
    )
  }
}

const mapStateToProps = state => ({ activeOrders: state.order.activeOrders });
const mapDispatchToProps = {};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrdersByDate));



// WEBPACK FOOTER //
// ./src/components/Orders/ByDate.js